<template>
  <main class="main" role="main">
    <Overlay :active="overlayActive" />
    <div class="inner wrapper">
      <BicTitle
        :term="term"
        :mode="mode"
      />
      <Message
        :messageType="messageType"
        :message="message"
      />
      <MainForm
        :term="term"
        :mode="mode"
        :nbResults="nbResults"
        :routeName="routeName"
        :helpForSearchTerm="helpForSearchTerm"
        :industry="industry"
        :industryOptions="industryOptions"
        :sector="sector"
        :sectorOptions="sectorOptions"
        :category="category"
        :categoryOptions="categoryOptions"
        :industryLoading="industryLoading"
        :sectorLoading="sectorLoading"
        :categoryLoading="categoryLoading"
        :searchSubmit="searchSubmit"
        :browseSubmit="browseSubmit"
        :updateIndustry="updateIndustry"
        :updateSector="updateSector"
        :updateCategory="updateCategory"
      />
      <Loading
        :loading="loading"
      />
      <Toolbar
        :nbResults="nbResults"
        :nbSelected="nbSelected"
        :linkSelected="linkSelected"
        :showSelected="showSelected"
        :displayList="displayList"
        :setShowSelected="setShowSelected"
        :clearWatchlist="clearWatchlist"
        :setDisplayList="setDisplayList"
      />
      <BicList
        :items="bics"
        :itemsSelected="bicsSelected"
        :alternateBicSource="alternateBicSource"
        :alternateBic="alternateBic"
        :itemsHelp="bicsHelp"
        :addToWatchlist="addToWatchlist"
        :removeFromWatchlist="removeFromWatchlist"
        :toggleBicsHelp="toggleBicsHelp"
        :getAlternateBic="getAlternateBic"
        :clearAlternateBic="clearAlternateBic"
        :showSelected="showSelected"
        :displayList="displayList"
        :setDisplayList="setDisplayList"
      />
    </div>
    <BicFooter
        :mode="mode"
    />
  </main>
</template>

<script>
  import Vue from 'vue';
  import MainForm from './components/MainForm.vue';
  import BicList from './components/BicList.vue';
  import Loading from './components/Loading.vue';
  import Message from './components/Message.vue';
  import Toolbar from './components/Toolbar.vue';
  import Overlay from './components/Overlay.vue';
  import BicFooter from './components/BicFooter.vue';
  import BicTitle from './components/BicTitle.vue';

  export default Vue.component('App', {
    props: {
      mode: String,
      routeName: String,
      term: String,
      helpForSearchTerm: String,
      loading: Boolean,
      messageType: String,
      message: String,
      industry: String,
      industryOptions: Array,
      sector: String,
      sectorOptions: Array,
      category: String,
      categoryOptions: Array,
      industryLoading: Boolean,
      sectorLoading: Boolean,
      categoryLoading: Boolean,
      bics: Array,
      bicsSelected: Array,
      alternateBicSource: String,
      alternateBic: Object,
      alternateBicLoading: Boolean,
      showSelected: Boolean,
      displayList: Boolean,
      bicsHelp: String,
      searchSubmit: Function,
      updateIndustry: Function,
      updateSector: Function,
      updateCategory: Function,
      browseSubmit: Function,
      getAlternateBic: Function,
      clearAlternateBic: Function,
      addToWatchlist: Function,
      removeFromWatchlist: Function,
      clearWatchlist: Function,
      toggleBicsHelp: Function,
      setShowSelected: Function,
      setDisplayList: Function,
    },
    // mounted: function() {
    //   console.log();
    // },
    computed: {
      nbResults: function() {
        return this.bics.length;
      },
      nbSelected: function() {
        return this.bicsSelected.length;
      },
      linkSelected: function() {
        if (this.nbSelected) {
          const codes = this.bicsSelected.map(bic => bic.code);
          return `/selected?codes=${codes.join(',')}`;
        }
        return null;
      },
      overlayActive: function() {
        if (this.alternateBicSource) {
          return true;
        }
        return false;
      },
    }
  });
</script>